module.exports = __webpack_public_path__ + "img/img_sneaker_new_2.a104745b.png";